<span class="pointer" (click)="show($event)"><ng-content></ng-content></span>
<div
  bsModal
  #deleteModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="Delete"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title text-center" style="width: 100%">Delete</div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="cancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete {{name}}?
        <br />
        <div class="row mt-3">
          <div class="col-sm-12">
            <cancel-button
              class="float-right"
              (click)="cancel()"></cancel-button>
            <button
              type="button"
              class="btn btn-primary float-right mr-2"
              (click)="delete()">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
